import { render, staticRenderFns } from "./ApplianceModelList.vue?vue&type=template&id=11b9ef7f"
import script from "./ApplianceModelList.vue?vue&type=script&lang=js"
export * from "./ApplianceModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports